import React, { Dispatch, SetStateAction } from 'react'
import { useIntl } from 'react-intl'
import { DataActivityTypes } from '../../core/_models'
import Skeleton from 'react-loading-skeleton'
import { OverviewBarColumnChart } from './OverviewBarColumnChart'

export const OverviewDataActivity = ({
  dataActivity,
  isLoading,
  selectedDataActivity,
  setSelectedDataActivity,
}: {
  dataActivity: DataActivityTypes
  isLoading: boolean
  selectedDataActivity: string
  setSelectedDataActivity: Dispatch<SetStateAction<string>>
}) => {
  const { formatMessage } = useIntl()

  return (
    <>
      <div className='bg-white rounded-2 py-6'>
        <div className='px-6 py-0 mb-5 d-flex justify-content-between'>
          <div>
            <h1 className='font-size-13'>{formatMessage({ id: 'Data Activity' })}</h1>
            {isLoading ? (
              <div className='d-flex'>
                <div className='me-2'>
                  <Skeleton
                    height={15}
                    width={120}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                </div>
                <div className='me-2'>
                  <Skeleton
                    height={15}
                    width={120}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                </div>
              </div>
            ) : (
              <div className='d-flex gap-1'>
                <div className='font-size-10 text-muted d-flex gap-1'>
                  <div
                    style={{
                      width: '14px',
                      height: '14px',
                      borderRadius: '50%',
                      backgroundColor: '#4776E6',
                    }}
                  />
                  <div className='d-flex me-3'>
                    <div style={{ fontWeight: 'bold' }} className='text-dark me-1'>
                      {`${dataActivity.uploadedFileSizes
                        .reduce((acc, item) => acc + item.totalSizeInNumber, 0)
                        .toFixed(2)}  MB`}
                    </div>
                    <span>{formatMessage({ id: 'Uploaded' })}</span>
                  </div>
                </div>
                <div className='font-size-10 text-muted d-flex gap-1'>
                  <div
                    style={{
                      width: '14px',
                      height: '14px',
                      borderRadius: '50%',
                      backgroundColor: '#0D216D',
                    }}
                  />
                  <div className='d-flex'>
                    <div style={{ fontWeight: 'bold' }} className='text-dark me-1'>
                      {dataActivity.downloadedFileSizes
                        .reduce((acc, item) => acc + item.totalSizeInNumber, 0)
                        .toFixed(2)}{' '}
                      MB
                    </div>

                    <span>{formatMessage({ id: 'Downloaded' })}</span>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className='dropdown-center'>
            <select
              className='form-select form-select-sm form-select-solid'
              data-control='select2'
              data-placeholder='Latest'
              data-hide-search='true'
              value={selectedDataActivity}
              onChange={(e) => setSelectedDataActivity(e.target.value)}
            >
              <option value='thisWeek'>{formatMessage({ id: 'This Week' })}</option>
              <option value='thisMonth'>{formatMessage({ id: 'This Month' })}</option>
              <option value='last6Months'>{formatMessage({ id: 'Last 6 Months' })}</option>
              <option value='thisYear'>{formatMessage({ id: 'This Year' })}</option>
            </select>
          </div>
        </div>
        {isLoading ? (
          <div className='px-6'>
            <Skeleton
              height={300}
              width={'100%'}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
          </div>
        ) : (
          <OverviewBarColumnChart dataActivity={dataActivity} />
        )}
      </div>
    </>
  )
}
